import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginWithEmail: boolean;
  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {}

  async login(providerString: string) {
    try {
      await this.auth.socialLogin(providerString);
      this.router.navigateByUrl('');
    } catch (e) {}
  }
}
